module.exports = __webpack_public_path__ + "712a81393ecad692ac70a28898a5d639.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/01-Betsolutions-Zeppelin.png
// module id = 1723
// module chunks = 2